import React, { useState, useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
var SignaturePad = function (_a) {
    var onComplete = _a.onComplete, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    var _c = useState('draw'), mode = _c[0], setMode = _c[1]; // 'draw' or 'upload'
    var _d = useState(null), uploadedImage = _d[0], setUploadedImage = _d[1];
    var sigCanvas = useRef(null);
    var fileInputRef = useRef(null);
    var handleClear = function () {
        if (mode === 'draw' && sigCanvas.current) {
            sigCanvas.current.clear();
        }
        else if (mode === 'upload') {
            setUploadedImage(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        }
    };
    var handleComplete = function () {
        var base64Data = '';
        if (mode === 'draw' && sigCanvas.current) {
            if (!sigCanvas.current.isEmpty()) {
                base64Data = sigCanvas.current.toDataURL();
            }
        }
        else if (mode === 'upload' && uploadedImage) {
            base64Data = uploadedImage;
        }
        if (base64Data) {
            onComplete(base64Data);
        }
        else {
            alert('Please provide a signature before completing');
        }
    };
    var handleFileUpload = function (e) {
        var file = e.target.files[0];
        if (file && file.type.startsWith('image/')) {
            var reader = new FileReader();
            reader.onload = function (event) {
                setUploadedImage(event.target.result);
            };
            reader.readAsDataURL(file);
        }
    };
    var switchMode = function (newMode) {
        setMode(newMode);
        handleClear();
    };
    return (React.createElement("div", null,
        React.createElement("div", { className: "flex" },
            React.createElement("button", { onClick: function () { return switchMode('draw'); }, className: "px-3 py-1 rounded-tl-lg font-medium transition-colors ".concat(mode === 'draw'
                    ? 'bg-primary text-white'
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'), disabled: disabled }, "Draw Signature"),
            React.createElement("button", { onClick: function () { return switchMode('upload'); }, className: "px-3 py-1 rounded-tr-lg font-medium transition-colors ".concat(mode === 'upload'
                    ? 'bg-primary text-white'
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300'), disabled: disabled }, "Upload Image")),
        React.createElement("div", { className: "border-2 border-primary rounded-b-lg bg-gray-50 mb-2" }, mode === 'draw' ? (React.createElement(SignatureCanvas, { ref: sigCanvas, canvasProps: {
                className: 'w-full h-64 bg-white rounded-lg cursor-crosshair',
                style: { width: '100%', height: '200px' }
            }, backgroundColor: "white" })) : (React.createElement("div", { className: "h-[200px] flex items-center justify-center p-2" }, uploadedImage ? (React.createElement("img", { src: uploadedImage, alt: "Uploaded signature", className: "h-full w-full object-contain" })) : (React.createElement("div", { className: "text-center" },
            React.createElement("input", { ref: fileInputRef, type: "file", accept: "image/*", onChange: handleFileUpload, className: "hidden", id: "signature-upload" }),
            React.createElement("label", { htmlFor: "signature-upload", className: "cursor-pointer inline-flex flex-col items-center gap-2 text-gray-600 hover:text-gray-800" },
                React.createElement("svg", { className: "w-12 h-12", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24" },
                    React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" })),
                React.createElement("span", { className: "text-sm font-medium" }, "Click to upload signature image"))))))),
        React.createElement("div", { className: "flex gap-2 justify-end" },
            React.createElement("button", { onClick: handleClear, className: "px-3 py-1 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 font-medium transition-colors", disabled: disabled }, "Clear"),
            React.createElement("button", { onClick: handleComplete, className: "px-3 py-1 bg-green-600 text-white rounded-md hover:bg-green-600 font-medium transition-colors", disabled: disabled }, "Complete"))));
};
export default SignaturePad;
